import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router,ActivatedRoute } from '@angular/router';
import { EncrDecrService } from './../../services/encr-decr.service';
import { HttpClient } from '@angular/common/http';
import { FactoringInvoiceService } from './../../services/factoring-invoice.service';
import {saveAs as importedSaveAs} from "file-saver";

@Component({
  selector: 'app-download-file',
  templateUrl: './download-file.component.html',
  styleUrls: ['./download-file.component.css']
})
export class DownloadFileComponent implements OnInit {
  soa_id:any='';
  downloadUrl:any='';
  company_id:any='';
  
  constructor( private _router : Router,
    private toastr: ToastrService,
    private _activatedroute: ActivatedRoute,private EncrDecr: EncrDecrService,private _factInvoice:FactoringInvoiceService,private http: HttpClient) { }

  ngOnInit() {
   
     var curl= this._router.url;
     const soa_id=  curl.split('/').pop();
     //var decrypted = this.EncrDecr.get('123456$#@$^@1ERF', soa_id);
    // console.log(decrypted);
 
    
         this.soa_id=soa_id;
         // console.log(this.downloadLink);
         const soaModal={
            APIKEY : 'SOAV2@123',
            soa_id : this.soa_id,
          }
          this._factInvoice.getSoaInfoByid(soaModal)
          .subscribe(
            res => { 
                 this.downloadUrl= res.data.pdf_link;
                 this.soa_id= res.data.soa_id;
                 this.company_id= res.data.company_id;
            },  
          );
       
     
     
  }

  download(filename) { 
    
   // this.soa_id=decrypted;
    // console.log(this.downloadLink);
    const soaModal={
       APIKEY : 'SOAV2@123',
       soa_id : this.soa_id,
       company_id : this.company_id,
     }
     this._factInvoice.updateSoaMaster(soaModal)
     .subscribe(
       res => { 
	   
        var url=res.redirect_url_path+'?soa_id='+this.soa_id+'&cmp_id='+this.company_id+'';
        var newWindow = window.open(url);
          
       },  
     );
  
     


     
  

 }




}
